import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import * as moment from 'moment';
import { InputDatepickerComponent } from '@ar2/common';
import { ViewChild } from '@angular/core';
/**
 * 日付入力フィールドカラム
 *【入力日付:inputDate:string】
 *【日付フォーマット:dateFormat:string】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-input-datepicker-column',
  templateUrl: './input-datepicker-column.html',
  styles: [`
    
  `]
})
export class InputDatepickerColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 入力日付の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 入力日付に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 日付フォーマット
   */
  @Input() dateFormat:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  /**
   * 表示用日付
   */
  private displayDate:string
  /**
   * get datepicker
   */
  @ViewChild('datepicker')
  public inputDatepicker: InputDatepickerComponent;
  /**
   * 入力日付
   */
  private _inputDate:string
  @Input()
  set inputDate(target:string) {
    if (this._inputDate !== target) {
      this._inputDate = target
      if (this.inputDatepicker && !!target) {
        this.displayDate = moment(moment(target).toDate())
                            .format(this.inputDatepicker.currentDateFormatCulture);
      } else {
        this.displayDate = target
      }
    }
  }
  get inputDate():string {
    return this._inputDate
  }
  /**
   * format of ymd
   */
  private YMD = 'YYYY/MM/DD';
  /**
   * format of ym
   */
  private YM = 'YYYY/MM';
  /**
   * format of md
   */
  private MD = 'MM/DD';
  /**
   * 入力日付を更新する
   */
  updateSelectedDate(event, index) {
    let inputDateBefore = this.inputDate;
    const value:Date = event['date'];
    const formatter = this.dateFormat === 'ymd' ? this.YMD
                    : this.dateFormat === 'ym' ? this.YM
                    : this.dateFormat === 'md' ? this.MD
                    : this.YMD
    this._inputDate = value ? moment(value).format(formatter) : '';
    this.displayDate = value ? moment(value).format(this.inputDatepicker.currentDateFormatCulture) : '';
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => this._inputDate,
      {id:this.id, type:"click", source:new Event("click")},
      `update by ${this.id}`,
    ))
    this.eventHub.next({
      id: this.id,
      type: "click",
      source: {},
      index: index,
    })
    if (inputDateBefore !== this._inputDate) {
      this.records[index]['_changed'] = true
      this.eventHub.next({
        id: this.id,
        type: "change",
        source: {},
        index: index,
      })
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/input-datepicker-column/input-datepicker-column.component.ts